module.exports = __webpack_public_path__ + "img/computer.be5030ca.webp";